import { Link } from 'react-router-dom';
import { V3Routes } from '../../routes';
import * as React from 'react';
import { GlobalStatesV3 } from '../../../commonv3/states/GlobalStatesV3';
import { Button } from '../../../commonv3/components/atoms/buttons/Button';
import './homeLocationIntroductionCompletePage.module.scss';
import { SpBr } from '../../../commonv3/components/atoms/layouts/br';

export const HomeLocationIntroductionCompletePage = () => {
  return (
    <div styleName="complete-pane">
      <div styleName="header">
        ホーム拠点の設定が
        <SpBr />
        完了しました
      </div>
      <div styleName="text">
        ホーム拠点は<Link to={V3Routes.homeLocation()}>設定</Link>から
        <SpBr />
        いつでも変更ができます。
      </div>
      <div styleName="button-wrapper">
        <Button styleName="button" type="normal" size="l" onClick={() => GlobalStatesV3.routing.push(V3Routes.home())}>
          閉じる
        </Button>
      </div>
    </div>
  );
};
